module.exports = __webpack_public_path__ + "static/media/6.16.2e06104a.png";